import noop from 'mn-utils/noop';

type TName = 'PositionTable' | 'SettlementTable';
type TCallbacks = {
  [key: string]: () => {};
};

const callbacks: TCallbacks = {};

export const commit = (name: TName, update: () => {}): void => {
  callbacks[name] = update;
};

export const emit = (name: TName): void => {
  setTimeout(() => {
    (callbacks[name] || noop)();
  }, 1000);
};
